import React from 'react';
import { Divider as MuiDivider, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    height: theme.spacing(0.5),
    background: theme.palette.secondary.main
  }
}));

export const Divider = props => {
  const classes = useStyles();
  return <MuiDivider className={classes.root}/>
};